import React from "react";
import BlockContent from "@sanity/block-content-to-react";

export const BasicRichText = ({ blocks }) => (
  <BlockContent blocks={blocks} />
)
